export enum SmartMicroStatus {
  Off = 0,
  On = 1,
}

export interface SmartMicroCommand {
  guid: string;
  deKanal: number;
  status: SmartMicroStatus;
}
